var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card text-center col-sm-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Community Action on Harm Reduction Project (CAHR)")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(" Known as 'Hridaya Project', it was aimed at reducing transmission of HIV/AIDS among Injecting Drug Users (IDU's) as well as raising their concerns with the local bodies. It was implemented under FCRA funding from 2012 - 2016.\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning showGallery",
    on: {
      "click": _vm.visibleGallery
    }
  }, [_vm._v("Show Gallery")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated fadeOutDown",
      "appear": ""
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row gallery"
  }, [_vm._l((_vm.fileTitles), function(file) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-6"
    }, [_c('a', {
      staticClass: "lightbox",
      attrs: {
        "href": require(("./Hridya-pics/" + (file.name)))
      }
    }, [_c('img', {
      staticClass: "img-responsive rounded",
      attrs: {
        "src": require(("./Hridya-pics/" + (file.name))),
        "alt": file.alt
      }
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f06e92a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/Hridya/Hridya.vue
// module id = kX+5
// module chunks = 0